import { getTenantByCookies } from '@/utils/getTenantByCookies'

import { httpClient } from '../../httpClient'

type FinancialEstimateByRouteHttpResponse = {
  totalInvestment: number
  totalCostReduction: number
  totalRevenue: number
  nameRoute: string
}

type FinancialEstimateByRoute = {
  totalInvestment: number
  totalCostReduction: number
  totalRevenue: number
  route: string
}

type Params = {
  date?: Date
}

type Response = {
  financialEstimatesByRoute: FinancialEstimateByRoute[]
}

const getDashboardFinancialEstimatesByRoute = async ({
  date,
}: Params): Promise<Response> => {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    return {
      financialEstimatesByRoute: [
        {
          totalInvestment: -10,
          totalCostReduction: 20,
          totalRevenue: 30,
          route: 'Route 1',
        },
        {
          totalInvestment: -10,
          totalCostReduction: 20,
          totalRevenue: 30,
          route: 'Route 2',
        },
        {
          totalInvestment: -10,
          totalCostReduction: 20,
          totalRevenue: 30,
          route: 'Route 3',
        },
      ],
    }
  }

  const queryParmas = new URLSearchParams({
    ...(date && { date: date.toISOString() }),
  })

  const query = queryParmas.toString() ? `?${queryParmas.toString()}` : ''

  const { data } = await httpClient.get<FinancialEstimateByRouteHttpResponse[]>(
    `/ideas/dashboard/estimated-by-route${query}`,
  )

  const financialEstimatesByRoute = data.map((financialEstimate) => ({
    totalInvestment: financialEstimate.totalInvestment
      ? Number(financialEstimate.totalInvestment.toFixed(2))
      : 0,
    totalCostReduction: financialEstimate.totalCostReduction
      ? Number(financialEstimate.totalCostReduction.toFixed(2))
      : 0,
    totalRevenue: financialEstimate.totalRevenue
      ? Number(financialEstimate.totalRevenue.toFixed(2))
      : 0,
    route: financialEstimate.nameRoute,
  }))

  return {
    financialEstimatesByRoute,
  }
}

export { getDashboardFinancialEstimatesByRoute, type FinancialEstimateByRoute }
